import Vue from 'vue';
import VueRouter from 'vue-router';
import Chatroom from '../views/Chatroom/index.vue';
import Article from '../views/article.vue';
import MyRequest from '../views/myRequest.vue'; // Only used for open directly
import { isArticleOpen, isMyRequestOpen, emitOpenArticle, emitOpenMyRequest } from '@/common/eventBus';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Chatroom,
  },
  {
    path: '/article/:id',
    name: 'article',
    component: Article,
  },
  {
    path: '/myrequest',
    name: 'myrequest',
    component: MyRequest,
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // When user click back on his phone, if Aritcle Component (src/components/Article.vue) is show. just close it and leave in the same page: next().
  // Same as MyRequest (src/components/MyRequest/index.vue)
  // Those two components are imported and maintained in App.vue
  if (isArticleOpen || isMyRequestOpen) {
    emitOpenArticle({
      isOpen: false,
    });
    emitOpenMyRequest(false);
    next(false);
    return;
  }
  next();
});

export default router;
